module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-right-32ed3c2ca6a9660f76fde6e188deb7fd.svg";